<section class="configure-center">
  @if (!viewerPdfSource) {
    @if (hasPendingSource) {
      <div class="viewer-empty">{{ emptyPreparingMessage }}</div>
    } @else {
      <div class="viewer-empty">{{ emptyNoFileMessage }}</div>
    }
  } @else if (pdfLoadError) {
    <div class="viewer-error-box">
      <p>{{ pdfLoadError }}</p>
      @if (pdfLoadErrorDetail) {
        <p class="viewer-error-detail">Details: {{ pdfLoadErrorDetail }}</p>
      }
      @if (showStepOneButton) {
        <button type="button" class="secondary-light" (click)="goToStepOne.emit()">{{ stepOneButtonLabel }}</button>
      }
    </div>
  } @else if (pdfBootstrapError) {
    <div class="viewer-error-box viewer-error-box--warning">
      <p>{{ pdfBootstrapError }}</p>
      <button type="button" class="secondary-light" (click)="retryPreview.emit()">{{ retryButtonLabel }}</button>
    </div>
  } @else {
    @if (!showViewerInstance) {
      <div class="viewer-loading-shell">Reinitializing preview...</div>
    } @else {
      <ngx-extended-pdf-viewer
        [src]="viewerPdfSource"
        [attr.data-render-nonce]="viewerRenderNonce"
        [disableForms]="true"
        [textLayer]="false"
        [showFindButton]="false"
        [showPagingButtons]="true"
        [showPreviousAndNextPageButtons]="true"
        [showFirstAndLastPageButtons]="false"
        [showMovePageButton]="false"
        [showPageNumber]="true"
        [showPageLabel]="false"
        [showZoomButtons]="true"
        [showZoomDropdown]="true"
        [showSidebarButton]="false"
        [showSecondaryToolbarButton]="false"
        [showScrollingButtons]="false"
        [showRotateButton]="false"
        [handTool]="false"
        [showHandToolButton]="false"
        [showPresentationModeButton]="false"
        [showOpenFileButton]="false"
        [showPrintButton]="false"
        [showDownloadButton]="false"
        [showPropertiesButton]="false"
        [showPageFlipButton]="false"
        [showSpreadButton]="false"
        [showEditorButtons]="false"
        [height]="'calc(100vh - 5rem)'"
        [page]="viewerPageBinding"
        [rotation]="viewerRotation"
        (pdfLoadingStarts)="pdfLoadingStarts.emit()"
        (pdfLoaded)="pdfLoaded.emit()"
        (pdfLoadingFailed)="pdfLoadingFailed.emit($event)"
        (pagesLoaded)="pagesLoaded.emit($event)"
        (pageRendered)="pageRendered.emit($event)"
        (pageChange)="pageChange.emit($event)"
        (rotationChange)="rotationChange.emit($event)"
      ></ngx-extended-pdf-viewer>
    }

    @if (pdfLoading) {
      <div class="viewer-loading">Loading PDF...</div>
    }

    @if (canPlaceFields && fieldCount === 0) {
      <div class="viewer-drop-hint">Drop a field anywhere on this page</div>
    }
  }

  <ng-content select="[canvas-debug]"></ng-content>
</section>
